import { useSelector } from "react-redux";
import { IState } from "store/types";
import { AppContent, AppRoot } from "components/Layout";
import { TemplateSelectionPage } from "./templateSelection/TemplateSelectionPage";
import { AlignmentToolPage } from "./alignmentTool/AlignmentToolPage";
import { Login } from "./Login";
import { ProtectedRoute } from "components/route";
import { Router } from "@reach/router";
import { Home } from "./Home";
import ResponsiveAppBar from "../components/appBar/ResponsiveAppBar";
import { AlignmentSuccessPage } from "./alignmentTool/AlignmentSuccessPage";
import { SnackBar } from "components/snackbar";
import { AdminPage } from "./Admin";
import { RuleEditorPage } from "./admin/RuleEditorPage";

export const App = () => {
  const authenticating = useSelector((state: IState) => state.authenticatingUser);
  const user = useSelector((state: IState) => state.user);
  const showLogin = (user && !user.valid) || user === null;

  return (
    <>
      <AppRoot className="app-root">
        <AppContent>
          {showLogin && <Login />}
          {!showLogin && !authenticating && (
            <>
              <ResponsiveAppBar />
              {/* @ts-expect-error - @reach/router Router component type issue */}
              <Router primary={false}>
                <Home path="/" />
                <ProtectedRoute path="/admin" component={AdminPage} />
                <ProtectedRoute path="/admin/rule/:id" component={RuleEditorPage} />
                <ProtectedRoute path="/wizardStepOne" component={TemplateSelectionPage} />
                <ProtectedRoute path="/wizardStepTwo" component={AlignmentToolPage} />
                <ProtectedRoute path="/wizardStepThree" component={AlignmentSuccessPage} />
              </Router>
            </>
          )}
        </AppContent>
      </AppRoot>
      <SnackBar />
    </>
  );
};
